export const drillAndBlastTabs = {
  Generate: 'Generate',
  History: 'History',
  Guide: 'Guide',
};
